import { useSelector } from 'react-redux'
import { userInfoSelector } from '../selectors'

export function useUserInfo() {
  return useSelector(userInfoSelector)
}
